













import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
//@ts-ignore
import store from "../../store";
import {Notification} from "../../../types/notifications";

const TASK_STATE_TYPE_CUSTOM = 2;
const TYPE_NOTIFICATION_ACTIVITY = 'activityNotification';

@Component({
    components: {},
})

export default class NotificationsManager extends Vue {
    @Prop({required: true}) private readonly notification!: Notification.Activity;

    private playersLeft: number = 0;
    private activityId: number = 0;
    private contentPackId: number = 0;
    private needMorePlayersIsVisible: boolean = false;

    mounted(): void
    {
        if (this.notification.type === TYPE_NOTIFICATION_ACTIVITY) {
            this.needMorePlayersIsVisible = true;
            this.playersLeft = this.notification.data.params.difference;
            this.activityId = this.notification.data.params.activityId;
            this.contentPackId = this.notification.data.params.contentPackId;
        }
    }

    /**
     * Стейт игры
     * @private
     */
    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * Название выбранной игры
     * @return {string|*}
     */
    private get selectedGameName(): string
    {
        if (this.gameState.tasks.state.type === TASK_STATE_TYPE_CUSTOM) {
            //@ts-ignore
            return this.$t('message.custom_game');
        }

        const activity = store.getters.getActivityById(this.activityId);

        if (activity) {
            return activity.name;
        }

        //@ts-ignore
        return this.$t('message.choose_game');
    }

    /**
     * Закрыть уведомление
     * @private
     */
    private closeNotification(): void
    {
        this.$emit('close');
    }
}
